interface IGenericSectionProps {
  id: string;
  sectionClassname?: string;
  heading: string;
  headingClassname?: string;
  subheading: string;
  subheadingClassname?: string;
  description?: string;
  descriptionClassname?: string;
  icon?: React.ReactNode;
  iconClassname?: string;
  children: React.ReactNode;
  childrenClassname?: string;
}

export const GenericSection = ({
  id,
  sectionClassname = "bg-white",
  heading,
  headingClassname = "text-secondary",
  subheading,
  subheadingClassname = "text-heading",
  description,
  descriptionClassname = "text-paragraph",
  icon,
  iconClassname = "",
  children,
  childrenClassname = "",
}: IGenericSectionProps) => {
  return (
    <section
      id={id}
      className={`py-8 md:py-12 lg:py-16 ${sectionClassname}`}
      role="region"
      aria-labelledby={`${id}-heading`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center gap-3">
        <h3 className={`text-base font-semibold ${headingClassname}`}>
          {heading}
        </h3>

        <h2
          id={`${id}-heading`}
          className={`text-2xl lg:text-4xl font-bold ${subheadingClassname} ${!description && !icon ? "mb-6" : ""}`}
        >
          {subheading}
        </h2>

        {description && (
          <p
            className={`text-base leading-relaxed mb-6 ${descriptionClassname}`}
          >
            {description}
          </p>
        )}

        {!description && icon && (
          <div className={`mb-6 ${iconClassname}`}>{icon}</div>
        )}

        <div className={childrenClassname}>{children}</div>
      </div>
    </section>
  );
};
